import {css} from "styled-components"
import {ButtonCssProps} from "./index"

export const largeCss = css<ButtonCssProps>`
  ${({theme}) => css`
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 0.3px;
    padding: ${theme.spacing.two} ${theme.spacing.four};
  `}
`

export const smallCss = css<ButtonCssProps>`
  ${({theme}) => css`
    line-height: 14px;
    font-size: 12px;
    letter-spacing: 0.2px;
    padding: ${theme.spacing.one} ${theme.spacing.three};
  `}
`
